import { regionHelper } from "src/features/region";
import { config } from "src/common/config";

export const isBrandedVenueLoaderEnabled = () => {
    const isUK = regionHelper.isUK;
    const enableBrandedVenueLoading = config.enableBrandedVenueLoading === "1";

    return isUK && enableBrandedVenueLoading;
};
